var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-button',{attrs:{"classes":['tg-btn--search'],"round":"","icon":"search"},nativeOn:{"click":function($event){return _vm.clickHandler.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('component.btn.search')))])
}
var staticRenderFns = []

export { render, staticRenderFns }